import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { FaInfoCircle } from 'react-icons/fa';
import AnimatedModal from './AnimatedModal';
import BackendErrorMessage from '../../../components/BackendErrorMessage';

interface PublicarIntegracaoSigaModalProps {
  banca: any;
  onClose: () => void;
  onConfirm: () => void;
}

const PublicarIntegracaoSigaModal: React.FC<PublicarIntegracaoSigaModalProps> = ({ 
  banca, 
  onClose, 
  onConfirm 
}) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
      toast.success('Evento de integração SIGA publicado com sucesso!');
      onClose();
    } catch (error: any) {
      console.error('Erro ao publicar integração SIGA:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Erro ao publicar evento';
      if (errorMessage.includes('mock-oauth') || errorMessage.includes('grant code')) {
        toast.error('Serviço OAuth não disponível em ambiente local');
      } else {
        toast.error(BackendErrorMessage(error));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AnimatedModal isOpen={true} onClose={onClose}>
      <div style={{
        backgroundColor: 'white', padding: '32px', borderRadius: '12px',
        width: '480px', maxWidth: '90vw',
        boxShadow: '0 10px 25px rgba(0,0,0,0.15)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ 
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: '48px', height: '48px', borderRadius: '50%',
            backgroundColor: '#dbeafe', marginBottom: '12px'
          }}>
            <i className="bi bi-send" style={{ color: '#2563eb', fontSize: '20px' }}></i>
          </div>
          <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
            Publicar Integração SIGA
          </h3>
        </div>

        <div style={{ marginBottom: '24px' }}>
          <div style={{
            backgroundColor: '#dbeafe', padding: '16px', borderRadius: '8px',
            marginBottom: '16px', border: '1px solid #60a5fa',
            display: 'flex', alignItems: 'flex-start', gap: '12px'
          }}>
            <FaInfoCircle style={{ color: '#1e40af', fontSize: '16px', marginTop: '2px' }} />
            <div style={{ fontSize: '14px', color: '#1e3a8a' }}>
              Confirma a publicação do evento de integração SIGA para esta banca?
            </div>
          </div>

          <div style={{
            backgroundColor: '#f8f9fa', padding: '16px', borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}>
            <div style={{ marginBottom: '8px' }}>
              <strong>Banca:</strong> {banca.tipoBanca?.nome}
            </div>
            <div>
              <strong>Data:</strong> {banca.dataDeBanca?.data ? 
                new Date(banca.dataDeBanca.data).toLocaleDateString('pt-BR') : 'Não definida'}
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px', border: '1px solid #d1d5db',
              backgroundColor: 'white', borderRadius: '6px',
              cursor: 'pointer', fontSize: '14px', fontWeight: '500'
            }}
            disabled={loading}
          >
            Cancelar
          </button>
          
          <button
            onClick={handleConfirm}
            disabled={loading}
            style={{
              padding: '10px 20px', backgroundColor: '#2563eb',
              color: 'white', border: 'none', borderRadius: '6px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '14px', fontWeight: '500',
              opacity: loading ? 0.6 : 1,
              display: 'flex', alignItems: 'center', gap: '6px'
            }}
          >
            {loading ? 'Publicando...' : (
              <>
                <i className="bi bi-send" style={{ fontSize: '12px' }}></i>
                Confirmar Publicação
              </>
            )}
          </button>
        </div>
      </div>
    </AnimatedModal>
  );
};

export default PublicarIntegracaoSigaModal;
